/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Partner_Billing_Board_Block_WaitingInputs */



/**
* | output |
* | --- |
* | "Not yet invoiceable" |
*
* @param {Partner_Billing_Board_Block_WaitingInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const partner_billing_board_block_waiting = /** @type {((inputs?: Partner_Billing_Board_Block_WaitingInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Partner_Billing_Board_Block_WaitingInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Noch nicht fakturierbar")
	return /** @type {LocalizedString} */ ("Not yet invoiceable")
});